module.exports = __webpack_public_path__ + "static/media/welcometitle.a9b90e8e.png";